document.querySelectorAll('.ia-block-faq-filter').forEach(filterItem => {
    const list = document.querySelector('.ia-block-list-faq')
    filterItem.querySelectorAll('.ia-block-faq-filter__item__cta').forEach(filterCta => {
        filterCta.addEventListener('click', e => {
            const termId = e.target.dataset.filter

            filterItem.querySelector('.active').classList.remove('active')

            e.target.classList.add('active')

            list.querySelectorAll('.ia-block-list-faq__item').forEach(item => {
                if(item.dataset.filterFaq.includes(termId)){
                    item.classList.remove('hidden')
                    item.classList.remove('is-invisible')
                }else {
                    item.classList.add('hidden')
                    item.classList.remove('is-invisible')
                }
            })

            checkButton();
            hideExceededItems();
        })
    })

    
    let checkButton = () => {
        if(list.querySelectorAll(".ia-block-list-faq__item:not(.hidden)").length < 5){
            list.nextElementSibling.style.display = "none"
            list.nextElementSibling.querySelector('.wp-block-button__link').disabled = 'disabled'
        }else {
            list.nextElementSibling.style.display = "block"
            list.nextElementSibling.querySelector('.wp-block-button__link').disabled = false
        }
    }

    let hideExceededItems = () => {
        list.querySelectorAll(".ia-block-list-faq__item:not(.hidden)").forEach((item, index) => {
            if (index > 4) {
                item.classList.add('is-invisible');
            }
        })
    }

    list.nextElementSibling.querySelector('button').addEventListener('click', e => {
        e.preventDefault()
        const catToLoadMore = document.querySelector('.ia-block-faq-filter__item__cta.active').dataset.filter
        list.querySelectorAll('.ia-block-list-faq__item.is-invisible').forEach((item, index) => {
            if (index <= 4) {
                item.classList.remove('is-invisible');
            }
        })
        if(list.querySelectorAll('.ia-block-list-faq__item.is-invisible').length > 0) {
            
        }else {
            e.target.disabled = 'disabled'
        }
    })
    
    checkButton();
})
